interface LanguageFlagProps {
  lang: 'sv' | 'en';
  className?: string;
}

export default function LanguageFlag({ lang, className = 'h-4 w-5' }: LanguageFlagProps) {
  if (lang === 'sv') {
    return (
      <svg
        viewBox="0 0 20 14"
        className={className}
        aria-hidden="true"
        focusable="false"
      >
        <rect width="20" height="14" rx="1.5" fill="#006AA7" />
        <rect x="5" width="3" height="14" fill="#FECC00" />
        <rect y="5.5" width="20" height="3" fill="#FECC00" />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 20 14"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <rect width="20" height="14" rx="1.5" fill="#012169" />
      <path d="M0 0 20 14M20 0 0 14" stroke="#FFF" strokeWidth="3" />
      <path d="M0 0 20 14M20 0 0 14" stroke="#C8102E" strokeWidth="1.4" />
      <path d="M10 0v14M0 7h20" stroke="#FFF" strokeWidth="4.6" />
      <path d="M10 0v14M0 7h20" stroke="#C8102E" strokeWidth="2.4" />
    </svg>
  );
}